import { Lock } from "lucide-react";
import { useSettings } from "../context/SettingsContext";
import { usePremium } from "../context/PremiumContext";
import { FREE_TRANSLATIONS } from "../api";
import { promptUpgrade } from "../lib/upgrade";

const TRANSLATIONS = ["NLT", "NKJV", "ASV", "KJV", "WEB"];

export default function TranslationToggle({ className = "" }) {
  const { translation, setTranslation } = useSettings();
  const { isPremium, inApp } = usePremium();

  const isLocked = (t) => inApp && !isPremium && !FREE_TRANSLATIONS.includes(t);

  const pick = (t) => {
    if (isLocked(t)) {
      promptUpgrade("the NKJV translation", ["NKJV translation", "Explain any verse or chapter", "Onyx audio narration", "Devotionals, plans & Word Study"]);
      return;
    }
    setTranslation(t);
  };

  return (
    <div
      data-testid="translation-toggle"
      className={`inline-flex flex-wrap rounded-full border border-border bg-background/60 p-0.5 backdrop-blur-md ${className}`}
    >
      {TRANSLATIONS.map((t) => {
        const locked = isLocked(t);
        return (
          <button
            key={t}
            data-testid={`toggle-${t}`}
            onClick={() => pick(t)}
            className={`inline-flex items-center rounded-full px-3 py-1 text-xs font-semibold transition-colors ${
              translation === t ? "bg-primary text-primary-foreground" : "text-muted-foreground hover:text-foreground"
            }`}
          >
            {locked && <Lock className="mr-1 h-3 w-3 opacity-70" />}
            {t}
          </button>
        );
      })}
    </div>
  );
}
